import Profile from "../../../component/profilePage/profile";


export default function ProfilePage() {


  return (
    <div className=" px-8">
     <Profile />
    </div>
  );
}
